// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 * Run manifest written to /agent/run.json. Tells the container which project, plan and plan run it is working on, which type it is, and which prompt and image versions produced it.
 * @export
 * @interface AgentRunManifest
 */
export interface AgentRunManifest {
  /**
   *
   * @type {number}
   * @memberof AgentRunManifest
   */
  project?: number;
  /**
   *
   * @type {number}
   * @memberof AgentRunManifest
   */
  testPlan?: number;
  /**
   *
   * @type {number}
   * @memberof AgentRunManifest
   */
  testPlanRun?: number;
  /**
   *
   * @type {number}
   * @memberof AgentRunManifest
   */
  agent?: number;
  /**
   *
   * @type {string}
   * @memberof AgentRunManifest
   */
  agentType?: string;
  /**
   * How the harness executes this type, opencode or direct
   * @type {string}
   * @memberof AgentRunManifest
   */
  runtime?: string;
  /**
   * Values for the config inputs declared by the agent type definition. Keys are the input names from that definition, so they vary by type. A secret input holds the project secret's ID, never the secret value.
   * @type {{ [key: string]: string; }}
   * @memberof AgentRunManifest
   */
  fields?: { [key: string]: string };
  /**
   *
   * @type {number}
   * @memberof AgentRunManifest
   */
  systemPromptVersion?: number;
  /**
   *
   * @type {number}
   * @memberof AgentRunManifest
   */
  promptVersion?: number;
  /**
   *
   * @type {string}
   * @memberof AgentRunManifest
   */
  imageTag?: string;
}

export function AgentRunManifestFromJSON(json: any): AgentRunManifest {
  return {
    project: !exists(json, "project") ? undefined : json["project"],
    testPlan: !exists(json, "test_plan") ? undefined : json["test_plan"],
    testPlanRun: !exists(json, "test_plan_run")
      ? undefined
      : json["test_plan_run"],
    agent: !exists(json, "agent") ? undefined : json["agent"],
    agentType: !exists(json, "agent_type") ? undefined : json["agent_type"],
    runtime: !exists(json, "runtime") ? undefined : json["runtime"],
    fields: !exists(json, "fields") ? undefined : json["fields"],
    systemPromptVersion: !exists(json, "system_prompt_version")
      ? undefined
      : json["system_prompt_version"],
    promptVersion: !exists(json, "prompt_version")
      ? undefined
      : json["prompt_version"],
    imageTag: !exists(json, "image_tag") ? undefined : json["image_tag"],
  };
}

export function AgentRunManifestToJSON(value?: AgentRunManifest): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    project: value.project,
    test_plan: value.testPlan,
    test_plan_run: value.testPlanRun,
    agent: value.agent,
    agent_type: value.agentType,
    runtime: value.runtime,
    fields: value.fields,
    system_prompt_version: value.systemPromptVersion,
    prompt_version: value.promptVersion,
    image_tag: value.imageTag,
  };
}
